<template>
  <div class="sm:container w-full mx-auto sm:p-4 space-y-6 max-w-full">
    <div class="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
      <div class="md:col-span-2">
        <ProfileBox @update="getProfile" :user="user" :profile-id="props.profileId" />
      </div>
      <div class="space-y-9">
        <CommentsSection :profile="user" :profile-id="props.profileId" />
      </div>
    </div>
  </div>
  <Toaster />
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { Toaster } from '@/components/ui/toast'
import ProfileBox from './components/ProfileBox.vue'
import { useAxios } from '@/composables/useAxios'
import ProfileSkeleton from './components/ProfileSkeleton.vue'
import CommentsSection from './components/commentsSection/CommentsSection.vue'
import { Profile } from '@/interfaces/profiles/Profile'

const props = defineProps<{ profileId: number | string }>()
const axios = useAxios()
const user = ref<Profile>()

function getProfile() {
  axios.get(`/profile/${props.profileId}`)
    .then((res) => {
      user.value = { ...res.data, phoneNumber: res.data.phoneNumber?.slice(2,) }
    })
    .catch(err => {
      console.error('Error fetching profile:', err);
    })
}

onMounted(async () => {
  getProfile()
})
</script>
